import { createRouter, createWebHistory } from 'vue-router'
import HomeIndex from '../components/HomeIndex.vue'
import SiteMap from '../components/SiteMap.vue'
import SiteSearch from '../components/SiteSearch.vue'
import HotRank from '../components/HotRank.vue'
import AboutUs from '../components/AboutUs.vue'
import AboutContent from '../components/AboutContent.vue'
import ContactContent from '../components/ContactContent.vue'
import StatementContent from '../components/StatementContent.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeIndex,
    meta: { title: '' }
  },
  {
    path: '/sitemap',
    name: 'sites',
    component: SiteMap,
    meta: { title: '站点地图-玖寻导航-让你的上网更轻松' }
  },
  {
    path: '/search',
    name: 'search',
    component: SiteSearch,
    meta: { title: '站内搜索-玖寻导航-让你的上网更轻松' }
  },
  {
    path: '/hots',
    name: 'hots',
    component: HotRank,
    meta: { title: '热搜热榜-玖寻导航-让你的上网更轻松' }
  },
  {
    path: '/about',
    name: 'about',
    component: AboutUs,
    meta: { title: '关于我们-玖寻导航-让你的上网更轻松' },
    children:[
      {
        path: '',
        name: 'aboutus',
        component: AboutContent,
        meta: { title: '关于我们-玖寻导航-让你的上网更轻松' }
      },
      {
        path: 'contact',
        name: 'contact',
        component: ContactContent,
        meta: { title: '联系我们-玖寻导航-让你的上网更轻松' }
      },
      {
        path: 'statement',
        name: 'statement',
        component: StatementContent,
        meta: { title: '免责声明--玖寻导航__让你的上网更轻松' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

export default router